import { render, staticRenderFns } from "./ProlistsPanel.vue?vue&type=template&id=713b4783"
import script from "./ProlistsPanel.vue?vue&type=script&lang=js"
export * from "./ProlistsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports